import React, { Component } from 'react';
import config from 'react-global-configuration';
import { Link, Redirect} from 'react-router-dom';
import RequestApi from '../Miscelania/RequestApi';

import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class PaymentValuesEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      types_select: [
        { value: 'national', label: 'Diária - nacional' },
        { value: 'international', label: 'Diária - internacional' },
        { value: 'europe', label: 'Diária - Europa' },
        { value: 'transport', label: 'Indenização - transporte' },
        { value: 'deslocation', label: 'Indenização - deslocamento' },
        { value: 'base_chief', label: 'Indenização - representante operacional' },
        { value: 'gratification', label: 'Indenização - gratificação de cheque' },
      ],
      currencies_select: [
        { value: 'BRL', label: 'BRL' },
        { value: 'USD', label: 'USD' },
        { value: 'EUR', label: 'EUR' },
      ],
      posts_select: '',
      value: '',
      data: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeMultiple(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/pagamento/valores';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/pagamento/valores');
        if (responseJson.status === 'success') {
          self.setState({
            data: responseJson.data.main,
            posts_select: responseJson.data.posts_select,
            companies_select: responseJson.data.companies_select,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      type: this.state.type,
      post_id: this.state.post_id,
      value: this.state.value,
      currency: this.state.currency,
      company_id: this.state.company_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento/valores', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({ data: responseJson.data });
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete(datasave) {
    if (window.confirm('Tem certeza que deseja deletar esse grupo de pagamentos?')) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/pagamento/valores', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({ data: responseJson.data });
          self.refs.request_api.validate(responseJson, 'alert');
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Editar valores de diárias</h3>
      <Link to="/pagamentos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <div>
        <form onSubmit={this.add}>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Tipo:</label>
              <Select
                className=""
                name="type"
                value={this.state.type}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'type')}
                options={this.state.types_select}
                required
              />
            </div>
            <div className="col-md-6 form-group">
              <label>Cargo:</label>
              <Select
                className=""
                name="post_id"
                value={this.state.post_id}
                searchable={true}
                placeholder={''}
                multi={true}
                onChange={this.handleSelectChangeMultiple.bind(this, 'post_id')}
                options={this.state.posts_select}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 form-group">
              <label>Moeda:</label>
              <Select
                className=""
                name="currency"
                value={this.state.currency}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'currency')}
                options={this.state.currencies_select}
                required
              />
            </div>
            <div className="col-md-4 form-group">
              <label>Empresa:</label>
              <Select
                className=""
                name="company_id"
                value={this.state.company_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'company_id')}
                options={this.state.companies_select}
                required
              />
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Valor:</label>
                <input value={this.state.value} name="value" className="form-control" onChange={this.handleChange.bind(this, 'value')} placeholder="999,99" />
              </div>
            </div>
          </div>
          <hr/>
          <div>
            <button type="submit" className="btn btn-primary btn-lg btn-block" required><i className="fa fa-fw fa-save"></i> Salvar</button>
          </div>
        </form>
        <hr/>
        <h4 className="page-title">Valores cadastrados</h4>
        <hr/>
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-striped">
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Empresa</th>
                <th>Moeda</th>
                <th>Valor</th>
                <th>Cargos</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
            {Object.keys(self.state.data).map(function(k) {
              var pv = self.state.data[k];
              return (
                <tr>
                  <td>{pv.type_str}</td>
                  <td>{pv.company}</td>
                  <td>{pv.currency}</td>
                  <td>{pv.value_str}</td>
                  <td>{pv.posts}</td>
                  <td className="text-center">
                    <button onClick={() => self.delete({type: pv.type, currency: pv.currency, company_id: pv.company_id, post_ids: pv.post_ids})} className="btn btn-danger btn-sm"><i className="fa fa-trash"></i></button>
                  </td>
                </tr>
              );
            })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default PaymentValuesEdit;



// WEBPACK FOOTER //
// ./src/Components/PaymentValues/PaymentValuesEdit.js